import { Fragment, type ReactNode } from 'react';
import { cn } from '@/lib/core/utils/cn';

interface EyebrowTagsProps {
  /** Falsy entries are dropped; a `●` separator is inserted between the remaining labels. */
  labels: Array<string | null | undefined>;
  /** Rendered after the labels, e.g. a bookmark button. */
  trailing?: ReactNode;
  className?: string;
}

/** The small uppercase "MEMBERS ONLY • EAT&DRINK"-style tag row used across Explore. */
export function EyebrowTags({ labels, trailing, className }: EyebrowTagsProps) {
  const visible = labels.filter((label): label is string => !!label);
  if (visible.length === 0 && !trailing) return null;

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {visible.map((label, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <span className="text-jncquoi-neutral-500 text-[4px]" aria-hidden="true">
              ●
            </span>
          )}
          <span className="font-pp-neue-montreal text-jncquoi-neutral-700 text-[10px] font-semibold tracking-[0.5px] whitespace-nowrap uppercase">
            {label}
          </span>
        </Fragment>
      ))}
      {trailing}
    </div>
  );
}
